import React, { useEffect, useMemo, useRef, useState } from "react";
import Select from "react-select";
import Switch from "react-switch";
import { formatDate, generatePDF, onlyNumeric, vehicleNameRegex } from "../../commonClass/CommonValidation";
import { useNavigate } from "react-router-dom";
import { getAllData, postUsersData, verifytoken } from "../../../services/ApiCallingUserServices";
import { useDispatch, useSelector } from "react-redux";
import { loaderActions } from "../../../_actions/loader.actions";
import { ClearLocalStorage } from "../../commonClass/Session";
import { ExportExcel } from "../../commonClass/ExportExcel";
import { ConfirmationModal } from "../../../customControl/ConfirmationModal";
import CustomTable from "../../../customControl/CustomTable";
import CommonFilter from "../../../customControl/CommonFilter";

function Vehicalmaster() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [vehicleoptionId, setVehicleoptionId] = useState(1);
  const [vehicleoptionLabel, setVehicleoptionLabel] = useState({
    Name: "",
    exportName: ""
  });
  const [vehicleOption, setVehicleOption] = useState([])
  const [disableOption, setDisableOption] = useState(false)

  const [modalShow, setModalShow] = useState(false);
  const [activeId, setActiveId] = useState(true);
  const [btntxt, setBtnTxt] = useState("Add");
  const [editdisabled, setEditDisabled] = useState(true);
  const [fieldDisable, setFieldDisable] = useState(false);

  const [vehicleDataList, setVehicleDataList] = useState([]);
  const [filterList, setFilterList] = useState([]);

  const [selectCategoryOption, setSelectCategoryOption] = useState([])
  const [vehicleTypeOption, setVehicleTypeOption] = useState([])

  const [searchvalue, setSearchValue] = useState('');
  const [searchby, setSerachBy] = useState('All');
  const [searchDisabled, setSearchDisable] = useState(false);


  const user = useSelector((store) => store.userstatus.tba);
  const [useradd, setUserAdd] = useState(true);
  const [useredit, setUserEdit] = useState(true);
  const [userexport, setUserExport] = useState(true);

  const [formValue, setFormValue] = useState({
    VehicleDetailId: 0,
    VehicleName: "",
    VehicleCategoryId: 0,
    VehicleTypeId: 0,
    BaggageCapacity: null,
    IsActive: true,
  });

  const defaultCategoryData = {
    MaxAdultCap: null,
    MaxTotalCap: null,
    FreeInfantsCap: null
  }

  const [categoryData, setCategoryData] = useState(defaultCategoryData);
  const [formError, setFormError] = useState({});

  const [SelectCategoryId, setSelectCategoryId] = useState(0);
  const [VehicleTypeId, setVehicleTypeId] = useState(0);

  const selectCategoryId = useRef();
  const vehicleTypeId = useRef();
  const selectTypeId = useRef();

  const EmptyCategoryListMessage = "No active Vehicle Category available for this group.";

  const getvehicleheaderlist = async () => {
    await getAllData('/master/v1/getvehicleheaderlist')?.then(response => {
      if (response?.status) {
        const headerlist = response?.data?.map((obj) => {
          obj.exportlabel = obj?.label
            ?.split(" ")
            ?.filter((fil) => fil !== "-")
            ?.join(" ")
            ?.replace(/[*?:\\/[\]]/g, "_");
          return obj;
        });
        setVehicleOption(headerlist);
        const defaultSelected = headerlist?.find((fin) => fin?.value === vehicleoptionId);
        setVehicleoptionLabel((opt) => ({ ...opt, Name: defaultSelected?.exportlabel, exportName: defaultSelected?.exportlabel }))
      }
    })
  }

  const handleVehicleOptionChange = (e) => {
    setVehicleoptionId(e?.value);
    setVehicleoptionLabel((opt) => ({ ...opt, Name: e?.exportlabel, exportName: e?.exportlabel }))
  };


  // Getting Vehicle Data from API--------------------------------------------------------------

  const getvehiclelistdetails = async (id) => {
    setCategoryData(defaultCategoryData);
    setSelectCategoryId(0);

    const vehicleData = await getAllData(
      `/master/v1/getvehiclelistdetails?VehicleHeaderId=${id}`
    );

    if (vehicleData?.status) {
      const formattedData = (vehicleData?.data ?? []).map((obj) => ({
        ...obj,
        BaggageCapacity: obj?.BaggageCapacity ?? "N/A",
        Active: obj?.IsActive ? "Active" : "InActive",
        CreatedOnFormat: formatDate(obj?.CreatedOn),
      }));

      setVehicleDataList(formattedData);
      setFilterList(formattedData);
    } else {
      setVehicleDataList([]);
      setFilterList([]);
    }
  };

  // Getting Vehicle Data from API--------------------------------------------------------------

  //#region On Change Methods
  const handleChange = (name, value) => {
    setFormError({});
    setEditDisabled(true);
    setFormValue((form) => ({ ...form, [name]: value }));
  };


  const getvehiclecategorylist = async () => {
    setCategoryData(defaultCategoryData);
    await getAllData('/master/v1/getvehiclecategoryactivelist')?.then(response => {
      if (response?.status) {
        setSelectCategoryOption(response?.data)
      }
    })
  }

  const vehicleCategories = useMemo(() => {
    return selectCategoryOption?.filter((fil) => fil?.VehicleHeaderId === vehicleoptionId);
  }, [selectCategoryOption, vehicleoptionId])


  const handleSelectCategoryChange = (e) => {
    setFormError({});
    setEditDisabled(true);
    setSelectCategoryId(e?.value);
    setFormValue((form) => ({ ...form, VehicleCategoryId: e?.value }));
    setCategoryData((cat) => ({ ...cat, MaxAdultCap: e?.MaxAdultCap ?? 0, MaxTotalCap: e?.MaxTotalCap ?? 0, FreeInfantsCap: e?.FreeInfantsCap ?? 0 }))
  };


  const getvehicletypelist = async () => {
    await getAllData('/master/v1/getvehicletypelist').then(response => {
      if (response?.status) {
        setVehicleTypeOption(response?.data)
      }
    })
  }
  const handleVehicleTypeChange = (e) => {
    setFormError({});
    setEditDisabled(true);
    setVehicleTypeId(e.value);
    setFormValue((form) => ({ ...form, VehicleTypeId: e.value }));
  };

  const handleisActive = (e) => {
    if (btntxt === "Add") {
      setFormValue((form) => ({ ...form, IsActive: !activeId }));
      setActiveId(!activeId);
      setFormError({});
    } else {
      setModalShow(true);
    }
  };

  const handleConfirmation = (e) => {
    //setYesNoConfirm(e)
    if (e === true) {
      setFormValue((form) => ({ ...form, IsActive: !activeId }));
      setActiveId(!activeId);
      setEditDisabled(true);
      setFormError({});
    }
    setModalShow(false);
  };
  //#endregion

  //#region validations
  const validation = () => {
    let status = true;
    let error = {};

    const vehicleNamePattern = /^[A-Za-z0-9 ]{1,25}$/;

    if (formValue?.VehicleName?.trim()?.length === 0) {
      error.VehicleName = "Vehicle Name is required.";
    }
    else if (!vehicleNamePattern.test(formValue?.VehicleName)) {
      error.VehicleName = "Please enter a valid Vehicle Name.";
    }

    if (SelectCategoryId === 0) {
      error.selectCategoryId = "Vehicle Category is required.";
    }

    if (VehicleTypeId === 0) {
      error.vehicleTypeId = "Vehicle Type is required.";
    }
    if (formValue?.BaggageCapacity < 0 || formValue?.BaggageCapacity > 20) {
      error.BaggageCapacity = "Baggage Capacity must be a whole number.";
    }


    setFormError(error);

    if (Object.keys(error)?.length > 0) {
      status = false;
      focusFirstError(error);
    }

    return status;
  };
  //#endregion

  const focusFirstError = (error) => {
    const firstError = Object.keys(error)?.[0];

    if (!firstError) return;

    const focusRefs = {
      selectCategoryId: selectCategoryId,
      vehicleTypeId: vehicleTypeId,
      selectTypeId: selectTypeId,
    };

    if (focusRefs[firstError]?.current) {
      focusRefs[firstError].current.focus();
      return;
    }

    document.getElementById(firstError)?.focus();
  };

  const checkDuplicateError = () => {
    const hasDuplicate = vehicleDataList?.some(
      (item) =>
        item?.VehicleDetailId !== formValue?.VehicleDetailId &&
        item?.VehicleName?.trim() === formValue?.VehicleName?.trim()
    );

    if (hasDuplicate) {
      setFormError({
        Duplicate: "This Vehicle Name already exists.",
      });

      return false;
    }

    setFormError({});
    return true;
  };

  //#region Add/Update Data
  const handleAdd = async (e) => {
    e.preventDefault();
    if (validation() && checkDuplicateError()) {
      let statusoftoken = await verifytoken();
      if (statusoftoken) {
        setEditDisabled(false);
        const data = {
          VehicleHeaderId: vehicleoptionId,
          VehicleDetailId: formValue?.VehicleDetailId,
          VehicleName: formValue?.VehicleName?.trim(),
          VehicleCategoryId: formValue?.VehicleCategoryId,
          VehicleTypeId: formValue?.VehicleTypeId,
          BaggageCapacity: formValue?.BaggageCapacity,
          IsActive: formValue?.IsActive,
        }
        const VehicleData = await postUsersData("/master/v1/insertorupdatevehicledetails", data);
        if (VehicleData.status) {
          getvehiclelistdetails(vehicleoptionId);
          dispatch({ type: 'ALERTING', message: VehicleData.message })
          clear();
        }
        else {
          dispatch({ type: 'ALERTING', message: VehicleData.message })
          return;
        }
      }
      else {
        ClearLocalStorage();
        dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
      }
    }
  };

  //#endregion

  //#region Clear Data
  const handleClear = (e) => {
    clear();
  };

  function clear() {
    setSearchDisable(false)
    setDisableOption(false)
    setFormValue({
      ...formValue,
      VehicleName: "",
      VehicleDetailId: 0,
      VehicleCategoryId: 0,
      VehicleTypeId: 0,
      BaggageCapacity: null,
      IsActive: true,
    });
    setSelectCategoryId(0)
    setVehicleTypeId(0)
    setFormError({});
    setActiveId(true);
    getvehiclelistdetails(vehicleoptionId);
    setBtnTxt("Add");
    setEditDisabled(true);
    setFieldDisable(false);
    setSearchValue("");
    setSerachBy("All");
  }
  //#endregion

  //Columns
  const columns = useMemo(() =>
    [
      {
        name: "Vehicle Name",
        key: "VehicleName",
        sortable: true,
        float: "left",
        selector: (row) => row?.VehicleName,
      },
      {
        name: "Vehicle Category",
        key: "VehicleCategory",
        sortable: true,
        float: "left",
        selector: (row) => row?.VehicleCategory,
      },
      {
        name: "Vehicle Group",
        key: "VehicleHeader",
        sortable: true,
        float: "left",
        selector: (row) => row?.VehicleHeader,
      },
      {
        name: "Max Adult (cap)",
        key: "MaxAdultCap",
        sortable: true,
        float: "left",
        selector: (row) => row?.MaxAdultCap,
      },
      {
        name: "Max Total (cap)",
        key: "MaxTotalCap",
        sortable: true,
        float: "left",
        selector: (row) => row?.MaxTotalCap,
      },
      {
        name: "Free Infants (cap)",
        key: "FreeInfantsCap",
        sortable: true,
        float: "left",
        selector: (row) => row?.FreeInfantsCap,
      },
      {
        name: "Vehicle Type",
        key: "VehicleType",
        sortable: true,
        float: "left",
        selector: (row) => row?.VehicleType,
      },
      {
        name: "Baggage Capacity",
        key: "BaggageCapacity",
        sortable: true,
        float: "left",
        selector: (row) => row?.BaggageCapacity,
      },
      {
        name: "Active",
        key: "Active",
        sortable: true,
        float: "left",
        selector: (row) => row?.Active,
      },
      {
        name: "Create Date",
        key: "CreatedOnFormat",
        sortable: true,
        float: "left",
        selector: (row) => new Date(row?.CreatedOn),
        format: (row) => row?.CreatedOnFormat,
      },
      {
        name: "Edit",
        selector: (row) => (
          <button type="button" className="border-0 p-0 bg-transparent set_disableclr" disabled={!useredit}>
            <i className="fa fa-edit" onClick={() => handleEditView("Edit", row?.VehicleDetailId)}></i>
          </button>
        ),
      },
      {
        name: "View",
        selector: (row) => (
          <button type="button" className="border-0 p-0 bg-transparent set_disableclr">
            <i className="fa fa-eye" onClick={() => handleEditView("View", row.VehicleDetailId)}></i>
          </button>
        ),
      },
    ], [useredit]);

  const handleEditView = (type, id) => {
    setSearchDisable(true)
    setDisableOption(true)
    setFieldDisable(type === "Edit" ? false : true);
    setEditDisabled(false);
    setBtnTxt(type === "Edit" ? "Update" : "Add");
    RetriveData(id);
  }

  const RetriveData = async (id) => {
    const vehicleData = await getAllData(
      `/master/v1/getvehicledetailsbyid?VehicleDetailId=${id}`
    );

    setFormError({});

    const vehicle = vehicleData?.data?.find(
      (item) => item?.VehicleDetailId === id
    );

    if (!vehicle) return;

    setFormValue((form) => ({
      ...form,
      VehicleName: vehicle?.VehicleName,
      VehicleCategoryId: vehicle?.VehicleCategoryId,
      VehicleDetailId: vehicle?.VehicleDetailId,
      VehicleTypeId: vehicle?.VehicleTypeId,
      BaggageCapacity: vehicle?.BaggageCapacity,
      IsActive: vehicle?.IsActive,
    }));

    setActiveId(vehicle?.IsActive);
    setSelectCategoryId(vehicle?.VehicleCategoryId);
    setVehicleTypeId(vehicle?.VehicleTypeId);

    setCategoryData((cat) => ({
      ...cat,
      MaxAdultCap: vehicle?.MaxAdultCap ?? 0,
      MaxTotalCap: vehicle?.MaxTotalCap ?? 0,
      FreeInfantsCap: vehicle?.FreeInfantsCap ?? 0,
    }));
  };


  //#endregion

  //#region Exports
  const PDFExport = () => {
    const keys = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.key);
    const pdfColumns = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.name);
    const rows = vehicleDataList?.map((obj) => keys?.map((key) => obj[key]))
    generatePDF(pdfColumns, rows, vehicleoptionLabel?.exportName, vehicleoptionLabel?.exportName)
  };

  const ExcelExport = () => {
    const dispalyname = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.name);
    const fields = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.key);
    ExportExcel(dispalyname, fields, vehicleDataList, vehicleoptionLabel?.exportName, `${vehicleoptionLabel?.exportName}.xls`);
  };
  //#endregion

  //#region UseEffect
  useEffect(() => {
    async function fetchData() {
      dispatch(loaderActions.start());

      try {
        const statusoftoken = await verifytoken();

        if (statusoftoken) {
          setFormError({});
          setSearchValue("");
          setSerachBy("All");

          await getvehiclelistdetails(vehicleoptionId);
        } else {
          ClearLocalStorage();

          dispatch({ type: "SESSIONOUT", message: "Your Session Expired. Please Login Again!" });
        }
      } catch (error) {
        console.error(error);
      } finally {
        dispatch(loaderActions.end());
      }
    }

    fetchData();
  }, [vehicleoptionId]);

  useEffect(() => {
    async function fetchData() {
      dispatch(loaderActions.start());

      try {
        const statusoftoken = await verifytoken();

        if (statusoftoken) {
          const results = await Promise.allSettled([
            getvehicleheaderlist(),
            getvehiclecategorylist(),
            getvehicletypelist()
          ]);

          results?.forEach((result) => {
            if (result.status === "rejected") {
              console.error(result?.reason);
            }
          });
        } else {
          ClearLocalStorage();

          dispatch({ type: "SESSIONOUT", message: "Your Session Expired. Please Login Again!" });
        }
      } catch (error) {
        console.error(error);
      } finally {
        dispatch(loaderActions.end());
      }
    }

    fetchData();
  }, []);


  useEffect(() => {
    //check for rights
    if (user?.length > 0) {
      const pathname = window?.location?.pathname?.toLowerCase()
      const hasRights = user?.find((fil) => fil?.PageLink?.toLowerCase() === pathname)
      setUserAdd(hasRights?.URightAdd);
      setUserEdit(hasRights?.URightEdit);
      setUserExport(hasRights?.URightExport);
      if (!hasRights?.URightView) {
        navigate('/dashboard');
      }
    }
  }, [user]);
  //#endregion

  return (
    <>
      <div className="container-fluid mt-4 heading_color">
        <h3>Vehicle Master</h3>
      </div>
      <div className="container-fluid form_border py-5 mb-3">


        <div className="mb-3 ">
          <form action="">
            <div className="mb-3 row mx-1">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="row">
                  {formError?.Duplicate && (<div className="text-danger pb-3 text-center"> {formError?.Duplicate} </div>)}

                  <div className="col-12">
                    <div className="row">
                      <div className="col-lg-6 col-sm-6 ">
                        <div className="row">
                          <div className="col-lg-4 col-md-12 mb-1">
                            <label className="col-form-label required">
                              Vehicle Group
                            </label>
                          </div>
                          <div className="col-lg-8 mb-1 col-md-12">
                            <Select
                              className="select_dropdown dropdown"
                              options={vehicleOption}
                              value={vehicleOption?.filter(function (vehicleoption) {
                                return vehicleoption.value === vehicleoptionId;
                              })}
                              placeholder="Select Vehicle Group"
                              onChange={(e) => handleVehicleOptionChange(e)}
                              isDisabled={disableOption}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 col-sm-6 ">
                    <div className="row">
                      <div className="col-lg-4 col-md-12 mb-1">
                        <label className="col-form-label required" htmlFor="VehicleName">Vehicle Name</label>
                      </div>
                      <div className="col-lg-8 mb-1 col-md-12">
                        <input
                          className="form-control"
                          type="text"
                          id="VehicleName"
                          name="VehicleName"
                          value={formValue?.VehicleName}
                          onChange={(e) => handleChange(e.target.name, vehicleNameRegex(e.target.value))}
                          placeholder="Vehicle Name"
                          maxLength={25}
                          disabled={fieldDisable ? true : false}
                        />
                        {formError?.VehicleName && (<div className="text-danger">{formError?.VehicleName}</div>)}
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 col-sm-6 ">
                    <div className="row">
                      <div className="col-lg-4 col-md-12 mb-1">
                        <label className="col-form-label required">
                          Vehicle Category
                        </label>
                      </div>
                      <div className="col-lg-8 mb-1 col-md-12">
                        <Select
                          ref={selectCategoryId}
                          id="SelectCategoryId"
                          className="dropdown select_dropdown"
                          options={vehicleCategories}
                          value={vehicleCategories?.filter(function (category) {
                            return category.value === SelectCategoryId;
                          })}
                          onChange={(e) => handleSelectCategoryChange(e)}
                          placeholder="Select Vehicle Category"
                          isDisabled={fieldDisable ? true : false}
                          isSearchable
                        />
                        {vehicleCategories?.length <= 0 && (<div className="text-danger">{EmptyCategoryListMessage}</div>)}
                        {formError?.selectCategoryId && (<div className="text-danger">{formError?.selectCategoryId}</div>)}
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 col-sm-6 ">
                    <div className="row">
                      <div className="col-lg-4 col-md-12 mb-1">
                        <label
                          className="col-form-label"
                          htmlFor="MaxAdultCap"
                        >
                          Max Adult (cap)
                        </label>
                      </div>
                      <div className="col-lg-8 mb-1 col-md-12">
                        <input
                          className="form-control"
                          type="text"
                          id="MaxAdultCap"
                          name="MaxAdultCap"
                          value={categoryData?.MaxAdultCap === null ? '' : categoryData?.MaxAdultCap}
                          onChange={() => { }}
                          placeholder="Max Adult (cap)"
                          disabled
                        />
                      </div>
                    </div>
                  </div>


                  <div className="col-lg-6 col-sm-6 ">
                    <div className="row">
                      <div className="col-lg-4 col-md-12 mb-1">
                        <label className="col-form-label required">
                          Vehicle Type
                        </label>
                      </div>
                      <div className="col-lg-8 mb-1 col-md-12">
                        <Select
                          ref={vehicleTypeId}
                          id="VehicleTypeId"
                          className="dropdown select_dropdown"
                          options={vehicleTypeOption}
                          value={vehicleTypeOption?.filter(function (type) {
                            return type.value === VehicleTypeId;
                          })}
                          onChange={(e) => handleVehicleTypeChange(e)}
                          placeholder="Select (AC / Non-AC)"
                          isDisabled={fieldDisable ? true : false}
                          isSearchable
                        />
                        {formError.vehicleTypeId && (<div className="text-danger">{formError.vehicleTypeId}</div>)}
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 col-sm-6 ">
                    <div className="row">
                      <div className="col-lg-4 col-md-12 mb-1">
                        <label
                          className="col-form-label"
                          htmlFor="FreeInfantsCap"
                        >
                          Free Infants (cap)
                        </label>
                      </div>
                      <div className="col-lg-8 mb-1 col-md-12">
                        <input
                          className="form-control"
                          type="text"
                          id="FreeInfantsCap"
                          name="FreeInfantsCap"
                          value={categoryData?.FreeInfantsCap === null ? '' : categoryData?.FreeInfantsCap}
                          onChange={() => { }}
                          placeholder="Free Infants (cap)"
                          disabled
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 col-sm-6 ">
                    <div className="row">
                      <div className="col-lg-4 col-md-12 mb-1">
                        <label className="col-form-label mb-0 d-block lh-sm" htmlFor="MaxTotalCap">Max Total (cap)</label>
                        <span className="text-muted small">(Adult + Child)</span>
                      </div>
                      <div className="col-lg-8 mb-1 col-md-12">
                        <input
                          className="form-control"
                          type="text"
                          id="MaxTotalCap"
                          name="MaxTotalCap"
                          value={categoryData?.MaxTotalCap === null ? '' : categoryData?.MaxTotalCap}
                          onChange={() => { }}
                          placeholder="Max Total (cap)"
                          disabled
                        />
                      </div>
                    </div>
                  </div>


                  <div className="col-lg-6 col-sm-6 ">
                    <div className="row">
                      <div className="col-lg-4 col-md-12 mb-1">
                        <label
                          className="col-form-label"
                          htmlFor="BaggageCapacity"
                        >
                          Baggage Capacity
                        </label>
                      </div>
                      <div className="col-lg-8 mb-1 col-md-12">
                        <input
                          className="form-control"
                          type="text"
                          id="BaggageCapacity"
                          name="BaggageCapacity"
                          value={formValue?.BaggageCapacity === null ? '' : formValue?.BaggageCapacity}
                          onChange={(e) =>
                            Number(onlyNumeric(e.target.value)) >= 0 && Number(onlyNumeric(e.target.value)) <= 20
                            &&
                            handleChange(e.target.name, Number(onlyNumeric(e.target.value)))}
                          placeholder="Baggage Capacity"
                          maxLength={2}
                          disabled={fieldDisable ? true : false}
                        />
                        {formError.BaggageCapacity && (<div className="text-danger">{formError?.BaggageCapacity}</div>)}
                      </div>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="col-lg-6 col-sm-6">
                      <div className="row">
                        <div className="col-lg-4 col-md-12 mb-1">
                          <label className="col-form-label">Active</label>
                        </div>
                        <div className="col-auto col-lg-8" disabled={false}>
                          <Switch
                            onChange={handleisActive}
                            checked={activeId}
                            className="react-switch"
                            disabled={fieldDisable ? true : false}
                          />
                        </div>
                        <ConfirmationModal
                          show={modalShow}
                          onHide={() => setModalShow(false)}
                          noconfirm={() => handleConfirmation(false)}
                          yesconfirm={() => handleConfirmation(true)}
                        />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div className="d-flex justify-content-center mb-4">
              {useradd === false && btntxt === "Add" ?
                (<button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={(e) => handleAdd(e)} disabled={!useradd}>{btntxt}</button>)
                :
                (<button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={(e) => handleAdd(e)} disabled={editdisabled ? false : true}>{btntxt}</button>)
              }
              <button type="button" className="btn btn-primary mx-1" id="btnClear" onClick={handleClear}>Clear</button>
            </div>

            <CommonFilter
              columns={columns}
              filterList={filterList}
              searchDisabled={searchDisabled}
              getdata={() => getvehiclelistdetails(vehicleoptionId)}
              setlistdata={setVehicleDataList}
              searchvalue={searchvalue}
              setSearchValue={setSearchValue}
              searchby={searchby}
              setSerachBy={setSerachBy}
            />

            <CustomTable
              columns={columns}
              data={vehicleDataList}
              PdfExport={PDFExport}
              ExportToExcel={ExcelExport}
              disabled={!userexport}
            />
          </form>
        </div>


      </div>
    </>
  );
}

export default Vehicalmaster;
